<template>
  <div>
    <div class="user_body">
      <div class="top_nav">
        <span class="title" @click="navClick(1)">我的评价</span>
      </div>

      <div class="search_top">
        <div class="tabs">
          <span :class="navIndex==0?'tab_select':'tab_nselect' " @click="navClick2(0)">待评价({{commentCounts.pending || 0}})</span>
          <span class="s_line">|</span>
          <span :class="navIndex==1?'tab_select':'tab_nselect' " @click="navClick2(1)">已评价({{commentCounts.completed || 0}})</span>
        </div>
        <el-input
          placeholder="输入产品名称、订单号"
          v-model="keyword"
          class="input"
          size="small"
          @keyup.enter.native="handleSearch"
        >
          <i slot="suffix" style="cursor: pointer;" class="el-input__icon el-icon-search" @click="handleSearch"></i>
        </el-input>
      </div>

      <div class="order_list">
        <div class="order_item" v-for="(item, index) in commentList" :key="index">
          <div class="o_t">
            <div class="order_top">
              <span class="o_text1">
                {{ navIndex == 0 ? '订单时间：' : '评价时间：' }}{{ navIndex == 0 ? item.createtime : item.commenttime }}&nbsp;&nbsp;&nbsp;&nbsp;订单号：{{ item.order_no }}
              </span>
              <div class="o_price" v-if="navIndex == 1">
                <el-rate v-model="item.score" :colors="colors" disabled show-text></el-rate>
              </div>
            </div>
          </div>
          <div class="order_info_list">
            <div class="order_info_item" v-for="(goods, index) in item.goods" :key="index">
              <img :src="goods.thumb" class="order_img">
              <div class="order_name_pr">
                <span class="o_text3">{{ goods.title }}</span>
                <span class="o_text3" v-if="goods.sku_name">{{ goods.sku_name }}</span>
                <span class="o_text4">{{ goods.price }}元&nbsp;&nbsp;&nbsp;X&nbsp;{{ goods.total }}</span>
                <!-- <span class="o_text4" v-if="navIndex == 1">{{ goods.content }}</span> -->
              </div>
              <div class="order_btns" v-if="index == 0">
                <span class="order_btns1" v-if="navIndex == 0" @click="openEvaluateDialog(item.id)">立即评价</span>
                <span class="order_btns1" v-if="navIndex == 1" @click="viewComment(item)">查看评价</span> 
              </div>
            </div>
          </div>
          <div class="imae_list" v-if="navIndex == 1 && item.images && item.images.length > 0">
            <img v-for="(img, imgIndex) in item.images" :key="imgIndex" :src="img" class="review-img" @click="previewImage(item.images, imgIndex)">
          </div>
        </div>
        <el-empty v-if="commentList.length === 0" description="暂无评价"></el-empty>
      </div>
      
      <div class="footer" v-if="commentList.length > 0">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next"
          :total="total"
          small
        ></el-pagination>
      </div>
 
    </div>
    <!-- 评价弹窗组件 -->
    <Evaluate 
      :dialog-visible.sync="evaluateDialogVisible" 
      :order-id="currentOrderId"
      @evaluate-success="handleEvaluateSuccess"
    />
    
    <!-- 查看评价详情弹窗 -->
    <el-dialog
      title="评价详情"
      :visible.sync="viewCommentDialogVisible"
      width="650px"
      custom-class="view-comment-dialog"
    >
      <div class="comment-detail" v-if="currentComment">
        <div class="comment-item">
          <div class="comment-label">商品信息：</div>
          <div class="comment-content">{{ currentComment.goods_name || currentComment.goods.title }}</div>
        </div>
        <div class="comment-item">
          <div class="comment-label">评分：</div>
          <div class="comment-content">
            <el-rate v-model="currentComment.score" disabled :colors="colors"></el-rate>
          </div>
        </div>
        <div class="comment-item">
          <div class="comment-label">评价内容：</div>
          <div class="comment-content">{{ currentComment.content }}</div>
        </div>
        <div class="comment-item" v-if="currentComment.images && currentComment.images.length > 0">
          <div class="comment-label">评价图片：</div>
          <div class="comment-content comment-images">
            <el-image 
              v-for="(img, index) in currentComment.images" 
              :key="index" 
              :src="img" 
              class="comment-img"
              :preview-src-list="currentComment.images"
            >
            </el-image>
          </div>
        </div>
        <div class="comment-item">
          <div class="comment-label">评价时间：</div>
          <div class="comment-content">{{ currentComment.createtime }}</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="viewCommentDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Evaluate from './componets/Evaluate.vue';
import bus from "@/components/eventBus.js";
export default {
  name: "SuggestionsView",
  components: {
    Evaluate
  },
  data() {
    return {
      currentIndex: 1,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      value2: 3,
      colors: ["#FF921D", "#FF921D", "#FF921D"],
      navIndex: 0,
      evaluateDialogVisible: false,
      currentOrderId: null,
      keyword: '',
      commentList: [],
      commentCounts: {
        pending: 0,
        completed: 0
      },
      viewCommentDialogVisible: false,
      currentComment: null
    };
  },
  mounted() {
    this.getCommentList();
    // this.getCommentCounts();
  },
  methods: {
    // 获取评价列表
    getCommentList() {
      this.$api.getCommentList({
        status: this.navIndex,
      }).then(res => {
        if (res.code == 1) {
          this.commentList = res.data.list || [];
          this.total = res.data.total || 0;
          this.commentCounts = {
            pending: res.data.count[0] || 0,
            completed: res.data.count[1] || 0
          }
        } else {
          this.$message.error(res.message);
        }
      }).catch(err => {
        console.log(err);
        this.$message.error('获取评价列表失败');
      });
    },
    
    // 切换标签
    navClick2(index) {
      this.navIndex = index;
      this.currentPage = 1;
      this.keyword = '';
      this.getCommentList();
    },
    
    // 搜索
    handleSearch() {
      this.currentPage = 1;
      this.getCommentList();
    },
    
    // 分页切换
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getCommentList();
    },
    
    // 打开评价弹窗
    openEvaluateDialog(orderId) {
      this.currentOrderId = orderId;
      this.evaluateDialogVisible = true;
    },
    
    // 评价成功回调
    handleEvaluateSuccess() {
      this.$message.success('评价成功');
      this.getCommentList();
      // this.getCommentCounts();
    },
    
    // 查看评价详情
    viewComment(comment) {
      this.currentComment = comment;
      this.viewCommentDialogVisible = true;
    },
    
    // 预览图片
    previewImage(images, index) {
      this.$util.previewImage({
        urls: images,
        current: index
      });
    },
    
    navClick(index) {
      this.currentIndex = index;
    }
  }
};
</script> 

<style lang="less" scoped>
.user_body {
  background: #ffffff;
  padding: 25px;
}
.top_nav {
  display: flex;
  flex-direction: row;
}
.title {
  color: #757575;
  font-size: 16px;
  width: 120px;
}
.title2 {
  color: #3c9c8f;
  font-size: 16px;
  width: 120px;
}
.search_top {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
}
.tabs {
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-top: 20px;
}
.input {
  width: 200px;
}
.tab_select {
  color: #3c9c8f;
  font-size: 14px;
  cursor: pointer;
}
.tab_nselect {
  color: #666666;
  font-size: 14px;
  cursor: pointer;
}
.s_line {
  margin-left: 15px;
  margin-right: 15px;
  size: 12px;
  color: #999999;
}
.order_item {
  border: 1px solid #f1f1f1;
  margin-top: 10px;
}
.o_t {
  background: #ffffff;
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
}
.order_top {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 5px;
  border-bottom: 1px solid #f1f1f1;
  padding: 10px 20px 10px 30px;
}
.o_text1 {
  color: #757575;
  font-size: 14px;
}
.o_text2 {
  color: #3c9c8f;
  font-size: 28px;
}
.o_text3 {
  color: #333333;
  font-size: 14px;
  width: 90%;
}
.o_text4 {
  color: #666666;
  font-size: 14px;
  width: 90%;
}
.o_text5 {
  color: #3c9c8f;
  font-size: 28px;
  border: 1px solid #3c9c8f;
  margin-top: 10px;
}
.order_info_list {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}
.order_info_item {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  padding: 10px 20px;
  box-sizing: border-box;
}
.imae_list {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 20px 10px 30px;
  box-sizing: border-box;
  flex-wrap: wrap;
}
.order_img {
  width: 80px;
  height: 80px;
  object-fit: cover;
}
.review-img {
  width: 60px;
  height: 60px;
  margin-right: 10px;
  margin-bottom: 10px;
  object-fit: cover;
  cursor: pointer;
}
.order_name_pr {
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: space-between;
  margin-left: 20px;
}
.order_name_pr span:nth-child(odd) {
  color: #333333;
  font-size: 14px;
  line-height: 20px;
}
.order_name_pr span:nth-child(even) {
  color: #666666;
  font-size: 14px;
  line-height: 20px;
  margin-top: 10px;
}
.order_btns {
  display: flex;
  flex-direction: column;
  margin-right: 20px;
}
.order_btns1 {
  background: #3c9c8f;
  font-size: 14px;
  color: white;
  width: 100px;
  text-align: center;
  height: 25px;
  line-height: 25px;
  cursor: pointer;
}
.order_btns2 {
  background: #ffffff;
  font-size: 14px;
  color: #757575;
  width: 100px;
  text-align: center;
  height: 23px;
  line-height: 25px;
  border: 1px solid #b0b0b0;
  margin-top: 10px;
  cursor: pointer;
}
.order_btns3 {
  background: #ffffff;
  font-size: 14px;
  color: #3c9c8f;
  width: 100px;
  text-align: center;
  height: 25px;
  line-height: 25px;
  margin-top: 10px;
  border: 1px solid #3c9c8f;
  cursor: pointer;
}
.footer {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}

// 评价详情弹窗样式
.view-comment-dialog {
  .comment-detail {
    padding: 0 20px;
  }
  
  .comment-item {
    margin-bottom: 15px;
    display: flex;
    
    .comment-label {
      width: 100px;
      color: #666;
      font-size: 14px;
      line-height: 24px;
    }
    
    .comment-content {
      flex: 1;
      color: #333;
      font-size: 14px;
      line-height: 24px;
    }
    
    .comment-images {
      display: flex;
      flex-wrap: wrap;
    }
    
    .comment-img {
      width: 80px;
      height: 80px;
      margin-right: 10px;
      margin-bottom: 10px;
      object-fit: cover;
      cursor: pointer;
    }
  }
}
.dialog-footer{
  padding-right: 20px;
}
</style>
  


